import { WidgetState } from 'state/widget/types';
import { DisplayUnitsState } from './types';

export type GetDisplayUnitsArgs = DisplayUnitsState &
  Pick<WidgetState, 'expectedNumberOfUnits' | 'unitOrder'>;

function getUnitsLimit(config: GetDisplayUnitsArgs) {
  const {
    defaultNumberOfUnits = Infinity,
    expectedNumberOfUnits,
    maxNumberOfUnits = Infinity,
  } = config;

  const baseNumberOfUnits = expectedNumberOfUnits ?? defaultNumberOfUnits;
  const clampedNumberOfUnits = Math.min(baseNumberOfUnits, maxNumberOfUnits);

  return clampedNumberOfUnits;
}

export default function getDisplayUnits(config: GetDisplayUnitsArgs): string[] {
  const { unitOrder } = config;

  if (!unitOrder || unitOrder.length === 0) {
    return [];
  }

  const limit = getUnitsLimit(config);
  return unitOrder.slice(0, limit);
}
